import { PurchaseRule } from "./PurchaseRule";
import { Tag } from "./Tag";

export interface PurchaseRuleLink {
    id?: ID;
    name?: string;
    seller: { id: ID };
    entities: PurchaseRuleLinkEntity[];
    purchaseRules: PurchaseRuleLinkPurchaseRule[];
    tags?: Tag[];
}

export interface PurchaseRuleLinkPurchaseRule {
    id?: ID;
    purchaseRule?: PurchaseRule | { id: ID };
    purchaseRulePermanentId?: ID;
    sequence: number;
    _remove?: boolean;
}

export interface PurchaseRuleLinkEntity {
    id: ID;
    object: PurchaseRuleLinkEntityObject;
}

export enum PurchaseRuleLinkEntityObject {
    AFFILIATE = "affiliate",
    EXPERIENCE = "experience",
    SELLER = "seller",
    PACKAGE = "package",
    MEMBERSHIP = "membership",
    PARTNER_PACKAGE = "partner_package",
    WARE = "ware",
}

export enum PurchaseRuleLinkTag {
    PRICING = "pricing",
    SCHEDULE = "schedule",
}

export enum PurchaseRuleInitialSequences {
    PARTNER_FINAL_PRICE_SEQUENCE_START = 8_500_001,
    PARTNER_FINAL_PRICE_SEQUENCE_END = 9_500_000,
    SCHEDULE_SEQUENCE = 7_500_001,
    BUYOUT_PRICING_SEQUENCE = 9_500_001,
}
